// extracted by css-extract-rspack-plugin
export default {"wrapper":"_602590e1","horizontal":"_cbe8254c","vertical":"_7c31dfe0","noGap":"_27065925","fullWidth":"_63106c27","overlay":"_16299448"};